import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PresenceConnection from "./components/PresenceConnection";
import "../src/styles/components.scss"

export default function Layout({user, onLogout, lang, setLang, children, appVersion}) {
    const location = useLocation();
    const isTaskPage = location.pathname.startsWith("/my-department")
        || location.pathname.startsWith("/my-tasks");

    return (
        <div className="app-layout container-fluid">
            <PresenceConnection user={user} />
            <Header />
            <main className={`main-content ${isTaskPage ? "task-main-content" : ""}`}>{children}</main>
            <Footer
                user={user}
                onLogout={onLogout}
                lang={lang}
                setLang={setLang}
                appVersion={appVersion}
            />
        </div>
    );
}
